import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import "./newsevent.css";









import WSDOimg1 from '../../assets/orp1.jpg';
import WSDOimg2 from '../../assets/orp2.jpg';
import WSDOimg3 from '../../assets/orp3.jpg';
import WSDOimg4 from '../../assets/orp4.jpg';
import WSDOimg5 from '../../assets/orp5.jpg';
import WSDOimg6 from '../../assets/orp6.jpg';

import WSDOimg8 from '../../assets/orp7.jpg';

import WSDOimg10 from '../../assets/orp9.jpg';
import WSDOimg11 from '../../assets/orp9.1.jpg';
import WSDOimg12 from '../../assets/orp10.jpg';
import WSDOimg9 from '../../assets/orp8.jpg';
import WSDOimg13 from '../../assets/orp11.jpg';
import WSDOimg14 from '../../assets/orp12.jpg';
import WSDOimg15 from '../../assets/orp13.jpg';
import WSDOimg16 from '../../assets/orp14.jpg';
import WSDOimg17 from '../../assets/orp15.jpg';
import WSDOimg18 from '../../assets/orp16.jpg';
import WSDOimg19 from '../../assets/orp17.jpg';
import WSDOimg20 from '../../assets/orp18.jpg';
import WSDOimg21 from '../../assets/orp19.jpg';
import WSDOimg22 from '../../assets/orp20.jpg';
import WSDOimg23 from '../../assets/orp21.jpg';
import WSDOimg24 from '../../assets/orp22.jpg';
import WSDOimg7 from '../../assets/orp6.1.jpg';





const sections = [
  {
   
    images: [WSDOimg1, WSDOimg2, WSDOimg3, WSDOimg4, WSDOimg5, WSDOimg6, WSDOimg8,  WSDOimg11, WSDOimg10,  WSDOimg12 , WSDOimg9, WSDOimg13, WSDOimg7,WSDOimg14, WSDOimg15, WSDOimg16 , WSDOimg17 , WSDOimg18,  WSDOimg19,  WSDOimg20, WSDOimg21, WSDOimg22 , WSDOimg23 , WSDOimg24],
  },
];








const OrientationProgramme = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(images);
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="gallery">
      <h1 align="center">Orientation Programme - 2025</h1>
      <p className="intro-annualmeeting">We're pleased to announce the successful completion of our inspiring and informative orientation session hosted by the Eye Care Institute, College of Optometry & Vision Science in Sri Lanka. This special event welcomed our new students with a comprehensive overview of their academic journey ahead, providing valuable insights into:

The institute's vision and academic excellence in optometry

Key program components and curriculum structure

Campus facilities and learning resources

Support services and student success initiatives

Participants gained meaningful orientation to begin their professional education in vision science. We extend our gratitude to all attendees, faculty members, and guest speakers who contributed to making this event a success.</p>
      <br />
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="gallery-section">
          <div className="gallery-header">
            <h2>{section.title}</h2>
          </div>
          <div className="gallery-grid">
            {section.images.map((src, index) => (
              <div key={index} className="gallery-item">
                <div className="overlay-container">
                <img
                    src={src}
                    alt={`Gallery item ${index + 1} in ${section.title}`} // Avoid the word "image"
                    className="gallery-image"
                    onClick={() => openViewer(section.images, index)}
                  />

                  <div className="overlay">
                    <button
                      className="max-view-button"
                      onClick={() => openViewer(section.images, index)}
                    >
                      <span>&#x2922;</span> {/* Fullscreen icon */}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {isViewerOpen && (
        <Lightbox
          mainSrc={currentImages[photoIndex]}
          nextSrc={currentImages[(photoIndex + 1) % currentImages.length]}
          prevSrc={
            currentImages[
              (photoIndex + currentImages.length - 1) % currentImages.length
            ]
          }
          onCloseRequest={closeViewer}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + currentImages.length - 1) % currentImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % currentImages.length)
          }
        />
      )}
    </div>
  );
};
export default OrientationProgramme